import { render, staticRenderFns } from "./Meals.vue?vue&type=template&id=5dcbd8eb&"
import script from "./Meals.vue?vue&type=script&lang=js&"
export * from "./Meals.vue?vue&type=script&lang=js&"
import style0 from "./Meals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports